import React from 'react'
import List from './List'
import { useStaffingAgencyBenefitsById, useStaffingAgencyHolidays } from 'src/queries'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const agency = useStaffingAgencyBenefitsById(id)
  const holidays = useStaffingAgencyHolidays()
  return (
    <List agency={agency} holidays={holidays} />
  )
}

export default Body
